module.exports = "https://cdn.thelire.com/ins/resource/cg_tab5_order@3x.35d5eb34ce0937bdfa421165180155b0.png";